<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t('general.institutions') }}</li>
            <li>{{ $t('institution.list.add_company') }}</li>
          </ul>
        </nav>
      </div>

      <div v-if="loading" class="card">
        <default-loading/>
      </div>
      <template v-else>

        <div class="card">
          <div v-for="error in errorMessages" v-if="errorMessages" class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color:red;">
              <i class="uil-exclamation-triangle"></i> {{ error }}
            </p>
          </div>
        </div>
        <div class="card row">
          <form action="" class="regular-form">
            <div class="uk-grid uk-child-width-1-2 uk-padding" uk-grid>
              <div>
                <h4><i class="uil-user-circle"></i> {{ $t('institution.information') }}</h4>
                <div class="form-group row mb-3">
                  <label class="col-md-12 col-form-label" for="logo">{{ $t('institution.avatar') }}<span
                      class="required">*</span></label>
                  <div class="col-md-12">
                    <div class="position-relative d-flex justify-center justify-content-center align-items-center">
                      <img alt="" class="rounded img-fluid logoarea" src="@/assets/images/no-photo.png">
                      <input id="avatar" accept="image/*" class="d-none" type="file" @change="processFile($event)">
                      <button class="btn btn-sm btn-outline-primary ml-2" type="button" @click="inputClick()">
                        {{ $t('general.image_change') }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-3">
                  <label class="col-md-12 col-form-label" for="logo">{{ $t('general.login_screen_image') }}</label>
                  <div class="col-md-12">
                    <div class="position-relative d-flex justify-center justify-content-center align-items-center">
                      <img alt="" class="rounded img-fluid logoarea2" src="@/assets/images/no-photo.png">
                      <input id="loginLogo" accept="image/*" class="d-none" type="file"
                             @change="processFileLogin($event)">
                      <button class="btn btn-sm btn-outline-primary ml-2" type="button" @click="inputLoginLogoClick()">
                        {{ $t('general.image_change') }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="surname">{{ $t('institution.list.company_name') }}<span
                        class="required">*</span></label>
                    <input id="surname" v-model="form.name" class="form-control" name="company_name" placeholder=""
                           required="" type="text">
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="start_date">{{ $t('institution.contract_start_date') }}<span
                        class="required">*</span></label>
                    <input id="start_date" v-model="form.start_date" class="form-control" name="start_date"
                           placeholder=""
                           required="" type="date">
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="end_date">{{ $t('institution.list.contract_expired_date') }}<span
                        class="required">*</span></label>
                    <input id="end_date" v-model="form.end_date" :min="form.start_date" class="form-control"
                           name="end_date"
                           placeholder="" required="" type="date">
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="domain">{{ $t('institution.domain_name') }}<span
                        class="required">*</span></label>
                    <input id="domain" v-model="form.domain" class="form-control" name="domain" placeholder=""
                           required=""
                           type="text">
                  </div>
                </div>

                <div class="form-group row domain uk-first-column">
                  <div class="col-md-12">
                    <label class="col-form-label">{{ $t('institution.alias_name') }}<span
                        class="required">*</span></label>
                    <div class="d-flex">
                      <input id="alias" v-model="form.alias" class="form-control" name="alias" placeholder=""
                             type="text">
                      <span>.softinya.com</span>
                    </div>
                  </div>
                </div>

                <!-- <div class="form-group row" v-if="isAdmin">
                  <div class="col-md-12">
                    <label class="col-form-label" for="domain">Anzera Eğitim Pini</label>
                    <input type="text" class="form-control" v-model="form.pin" placeholder="" required="">
                  </div>
                </div> -->
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="domain">{{ $t('general.parent_institution') }}</label>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <multiple-select-input :model.sync="company" :required="false" :searchable="true"
                                               :values="institutions" @select="form.parentCompanyId = $event.id"/>

                        <button v-if="form.parentCompanyId" class="btn btn btn-outline-secondary btn-block"
                                type="button"
                                uk-toggle="target: #modal_user_group_add">
                          <i class="uil-plus"></i> {{ $t('general.add_users') }}
                        </button>

                        <div v-if="form.parentCompanyId && checked_users_list?.length" class="mt-3">
                          <label class="col-form-label"><strong> {{ $t('general.selected_users') }} :</strong></label>
                          <div class="selected-users-list">
                            <span v-for="(user, index) in checked_users_list" :key="user.id" class="user-badge">
                              {{ user.fullname }}
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <CatalogTrainingList v-model="form.self_registrable_training_ids"
                                     :catalog-loading="catalogLoading"
                                     :items="catalogItems"
                                     :training-purchase-registration.sync="training_purchase_registration"
                                     @apply-filter="onCatalogFilter"
                />
              </div>
            </div>
            <div class="uk-card-footer pt-0">
              <div class="float-right">
                <button class="btn btn-primary btn-sm mt-2" type="button" @click="saveForm()">
                  <i class="uil-check"></i> {{ $t('general.save') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </template>
    </div>


    <div id="modal_user_group_add" class="uk-modal-full uk-modal" uk-modal="">
      <div class="uk-modal-footer bggray">
        <h3 class="float-left">
          <i class="uil-presentation-plus"></i>
          {{ $t('general.add_users') }}
        </h3>
        <button class="uk-button uk-button-default small uk-modal-close float-right" type="button">
          <i class="uil-times"></i> {{ $t("general.close") }}
        </button>
      </div>

      <div class="uk-modal-dialog bggray h-100">
        <div class="uk-padding-large position-relative uk-grid pt-0" uk-grid="">
          <div class="uk-width-5-5">
            <UserGroupSelection :key="'user-selection-' + form.parentCompanyId"
                                :added_users="checked_users"
                                :allow_both_selection="true"
                                :company_id="form.parentCompanyId"
                                :is-groups-active="false"
                                :with_description="true"
                                class="bg-white px-2 py-4 card"
                                @setCheckedUsers="($event) => { checked_users = $event.ids, checked_users_list = $event.items; }"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UserGroupSelection from "@/view/components/assignment/UserGroupSelection.vue";
import CatalogTrainingList from "@/view/company/Institution/components/CatalogTrainingList.vue";

const _COMPANY_MODULE_NAME = COMPANY_MODULE;
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";

import module, { BASE_URL, MODULE_NAME, ERROR, LOADING, CREATE_ITEM } from "@/core/services/store/company.module";
import store from '@/core/services'
import moment from "moment";
import $ from "jquery";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import { GET_ITEMS } from "@/core/services/store/REST.module";

const _TRAINING_KIND_MODULE = MODULE_TRAINING_KIND;
import Pagination from "@/view/components/dataTable/Pagination";
import axios from "axios";
import training_kind_module, {
  BASE_URL as TRAINING_KIND_URL,
  GET_ITEMS as GET_TRAINING_KINDS,
  MODULE_NAME as MODULE_TRAINING_KIND,
  ITEMS as TRAINING_KINDS
} from "@/core/services/store/training_kind.module";
import company_module, {
  BASE_URL as COMPANY_BASE_URL,
  GET_ITEMS as GET_INSTITUTIONS,
  MODULE_NAME as COMPANY_MODULE,
  ITEMS as INSTITUTIONS,
} from "@/core/services/store/company.module";
import { subCompany, parentCompany } from "@/core/services/store.js";

export default {
  name: "InstitutionAdd",
  components: {
    UserGroupSelection,
    DefaultLoading,
    Pagination,
    MultipleSelectInput,
    CatalogTrainingList,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(_TRAINING_KIND_MODULE, training_kind_module)
    registerStoreModule(MODULE_NAME, module);
    registerStoreModule(_COMPANY_MODULE_NAME, company_module);
  },
  data() {
    return {
      subCompany: subCompany,
      company: {
        id: null,
        name: null,
      },
      training_purchase_registration: false,
      form: {
        type: 'institution',
        name: '',
        domain: '',
        alias: '',
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add('1', 'year').format('YYYY-MM-DD'),
        avatar: '',
        loginLogo: '',
        pin: '',
        selected_type: {
          id: null,
          name: this.$t('education.all_categories')
        },
        self_registrable_training_ids: [],
        parentCompanyId: null,
      },
      institutions: [],
      search: null,
      searchResult: [],
      options: [0],
      kinds: [0],
      sort: 'desc',
      restUrl: 'api/training',
      educationTypes: [],
      selected_type: {
        id: null,
        name: this.$t('education.all_categories')
      },
      filters: {
        page: 1,
        search: '',
        training_type_id: 0,
        training_kind_id: 0,
        admin_page: true,
        can_show_self_registrable_trainings: true,
        company_id: null,
        perPage: 10,
        order_by: 'name',
      },

      successMessage: null,
      errorMessages: [],
      selected_type_name: null,
      trainingCategoryUrl: 'api/training-type',
      checked_users: [],
      checked_users_list: [],
      catalogItems: null,
      catalogLoading: false,

    }
  },
  computed: {
    training_kinds: {
      get() {
        return store.getters[_TRAINING_KIND_MODULE + '/' + TRAINING_KINDS]
      },
      set(value) {
      }
    },
    formattedTrainingKind() {
      let results = [];
      if (this.training_kinds === null || !("data" in this.training_kinds)) return [];
      this.training_kinds.data.forEach(item => {
        results.push({
          id: item.id,
          value: item.id,
          name: item.name
        });
      });
      return results;
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + '/' + ERROR]
      },
      set(value) {
      }
    },
    loading() {
      return store.getters[MODULE_NAME + '/' + LOADING]
    },
  },
  methods: {
    getInstitutions() {
      this.$store.dispatch(COMPANY_MODULE + "/" + GET_INSTITUTIONS, {
        url: COMPANY_BASE_URL,
        filters: {
          all: "all",
        },
      }).then((response) => {
        this.institutions = response
      });
    },
    formattedInstitution() {
      let results = [
        {
          id: null,
          name: this.$t("general.choose"),
        },
      ];
      if (this.institutions === null) return [];

      this.institutions.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
        });
      });
      return results;
    },
    onCatalogFilter(filterData) {
      this.$set(this.filters, 'page', filterData.page)
      if (!(this.options.length === 1 && this.options[0] === 0)) {
        this.$set(this.filters, 'training_type_id[]', this.options)
      }
      if (!(this.kinds.length === 1 && this.kinds[0] === 0)) {
        this.$set(this.filters, 'training_kind_id[]', this.kinds)
      }
      this.$set(this.filters, 'search', filterData.search)
      this.$set(this.filters, 'order_by', filterData.order_by)
      // Kurum ekleme sayfasında katalog eğitimleri için istekleri
      // REST store üzerinden değil, direkt axios ile yapıyoruz.
      this.catalogLoading = true;
      this.filters.company_id = this.form.parentCompanyId;

      axios.get(this.restUrl, {
        params: {
          page: this.filters.page,
          search: this.filters.search,
          training_type_id: this.filters.training_type_id,
          training_kind_id: this.filters.training_kind_id,
          admin_page: this.filters.admin_page,
          can_show_self_registrable_trainings: this.filters.can_show_self_registrable_trainings,
          company_id: this.filters.company_id,
          perPage: this.filters.perPage,
          order_by: this.filters.order_by,
        },
      })
          .then((response) => {
            this.catalogItems = response.data;
          })
          .catch(() => {
            this.catalogItems = null;
          })
          .finally(() => {
            this.catalogLoading = false;
          });
    },
    saveForm() {
      let form = this.form;
      this.errorMessages = [];
      if (form.avatar === null || form.avatar === "") {
        this.errorMessages.push(this.$t('general.required_institution_logo'));
        this.scrollToTop();
        return false;
      }
      if (form.name.length === 0) {
        this.errorMessages.push(this.$t('company.required.name'));
        this.scrollToTop();
        return false;
      }
      if (form.start_date.length === 0) {
        this.errorMessages.push(this.$t('company.required.start_date'));
        this.scrollToTop();
        return false;
      }
      if (form.end_date.length === 0) {
        this.errorMessages.push(this.$t('company.required.end_date'));
        this.scrollToTop();
        return false;
      }
      if (form.domain.length === 0) {
        this.errorMessages.push(this.$t('company.required.domain'));
        this.scrollToTop();
        return false;
      }
      if (form.alias.length === 0) {
        this.errorMessages.push(this.$t('company.required.alias'));
        this.scrollToTop();
        return false;
      }

      let formData = new FormData();

      formData.append('type', form.type);
      formData.append('name', form.name);
      formData.append('domain', form.domain);
      formData.append('alias', form.alias);
      formData.append('start_date', form.start_date);
      formData.append('end_date', form.end_date);
      formData.append('avatar', form.avatar);
      form.loginLogo ? formData.append('login_images[' + this.secureLocalStorage("language") + ']', form.loginLogo) :
          formData.append('login_images', []);
      formData.append('pin', form.pin);
      formData.append("training_purchase_registration", this.training_purchase_registration ? 1 : 0);
      formData.append("parentCompanyId", form.parentCompanyId);

      if (this.checked_users && this.checked_users.length) {
        for (let i = 0; i < this.checked_users.length; i++) {
          formData.append("user_ids[]", this.checked_users[i]);
        }
      }

      // if (this.allTraining) {
      //   formData.append('self_registrable_training_ids', 'all');
      // } else {
      for (let i = 0; i < form.self_registrable_training_ids.length; i++) {
        formData.append('self_registrable_training_ids[]', form.self_registrable_training_ids[i]);
        // }
      }

      store.dispatch(MODULE_NAME + '/' + CREATE_ITEM, {
        url: BASE_URL,
        contents: formData
      }).then(() => {
        if (!this.error) {
          this.$router.push({
            name: 'company.institutions.list',
            params: { 'succesMessage': this.$t('general.update_success') }
          })
        } else this.errorMessages.push(this.error)
      })
    },
    processFile(event) {
      let imageInput = event.target.files[0];
      if (!imageInput.type.includes('image/')) {
        this.errorMessages.push(this.$t('general.required_institution_logo'));
        return false
      }
      this.form.avatar = imageInput;
      let blob = URL.createObjectURL(imageInput);
      let imageHolder = $('.logoarea');
      imageHolder.attr('src', blob);
    },
    processFileLogin(event) {
      let imageInput = event.target.files[0];
      if (!imageInput.type.includes('image/')) {
        this.errorMessages.push(this.$t('general.required_institution_logo'));
        return false
      }
      this.form.loginLogo = imageInput;
      let blob = URL.createObjectURL(imageInput);
      let imageHolder = $('.logoarea2');
      imageHolder.attr('src', blob);
    },
    inputClick() {
      $('#avatar').click();
    },
    inputLoginLogoClick() {
      $('#loginLogo').click();
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
  },
  watch: {
    'form.parentCompanyId'(newValue, oldValue) {
      // parentCompanyId değiştiğinde seçili kullanıcıları sıfırla
      if (oldValue !== null && newValue !== oldValue) {
        this.checked_users = [];
      }
    },
  },
  mounted() {
    if (!this.$isSuperAdmin) {
      this.$router.push('/403');
    }
    if (!this.CatalogTrainingVisible) {
      this.$router.push({ name: 'company.dashboard' })
    }
    this.selected_type_name = this.$t('education.all_categories')
    let self = this;

    store.dispatch(_TRAINING_KIND_MODULE + '/' + GET_TRAINING_KINDS, {
      url: TRAINING_KIND_URL
    });

    this.$store.dispatch(GET_ITEMS, {
      url: this.trainingCategoryUrl,
      acceptPromise: true,
    }).then(
        (response) => {
          if (response.status) {
            self.educationTypes = response.data;
            self.educationTypes.unshift({ id: 0, name: this.$t('education.all_categories') });
          }
        }
    );
    this.getInstitutions();
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.uk-alert {
  margin: 0;
}

.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}

/* Seçili Kullanıcılar Listesi */
.selected-users-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.user-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #3e416d;
  color: white;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.user-badge:hover {
  background-color: #2d3154;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>